
import React from "react";
import {
    Box,
    Paper,
    Stack,
    Typography,
    useMediaQuery,
} from "@mui/material";

export default function CouponsList({ coupons = [],t }) {
    const isMobile = useMediaQuery("(max-width: 600px)");

    return (
        <Box sx={{ width: "100%" }}>
            <Paper
                elevation={0}
                sx={{
                    borderRadius: "20px",
                    backgroundColor: "#F5F5F5",
                    p: { xs: 1.5, md: 3 },
                }}
            >
                <Typography
                    sx={{
                        fontFamily: "'Roboto Condensed', sans-serif",
                        fontSize: 14,
                        lineHeight: "120%",
                        color: "#111111",
                        mb: 2,
                    }}
                >
                    {t("Here you can find all your available coupons.")}
                </Typography>
                <Stack spacing={1.2}>
                    {coupons.map((coupon) =>
                        isMobile ? (
                            <MobileCouponRow key={coupon.id} coupon={coupon} t={t} />
                        ) : (
                            <DesktopCouponRow key={coupon.id} coupon={coupon} t={t} />
                        )
                    )}
                </Stack>
            </Paper>
        </Box>
    );
}


function DesktopCouponRow({ coupon,t }) {
    return (
        <Paper
            elevation={0}
            sx={{
                borderRadius: "10px",
                backgroundColor: "#E9E9E9",
                px: 3,
                py: 1.5,
            }}
        >
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "3fr 1.5fr 1.5fr",
                    alignItems: "center",
                    columnGap: 2,
                    fontFamily: "'Roboto Condensed', sans-serif",
                    fontSize: 14,
                    color: "#111111",
                }}
            >
                <Typography
                    sx={{
                        fontFamily: "'Roboto Condensed', sans-serif",
                        fontSize: 14,
                        lineHeight: "120%",
                        color: "#111111",
                    }}
                >
                    {coupon.description}
                </Typography>

                <Box
                    sx={{
                        textAlign: "right",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        gap: 0.3,
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: "'Roboto Condensed', sans-serif",
                            fontWeight: 700,
                            fontSize: 12,
                            textTransform: "uppercase",
                            color: "#111111",
                        }}
                    >
                        {t("Coupon Code")}
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: "'Roboto Condensed', sans-serif",
                            fontWeight: 700,
                            fontSize: 14,
                            color: "#E5007E",
                        }}
                    >
                        {coupon.code}
                    </Typography>
                </Box>
                <Typography
                    sx={{
                        fontFamily: "'Roboto Condensed', sans-serif",
                        fontSize: 14,
                        textAlign: "right",
                        color: "#111111",
                    }}
                >
                    {coupon.validUntil}
                </Typography>
            </Box>
        </Paper>
    );
}

function MobileCouponRow({ coupon,t }) {
    return (
        <Paper
            elevation={0}
            sx={{
                borderRadius: "10px",
                backgroundColor: "#E9E9E9",
                px: 2,
                py: 1.5,
            }}
        >
            <Stack
                spacing={0.8}
                sx={{
                    fontFamily: "'Roboto Condensed', sans-serif",
                    fontSize: 14,
                    color: "#111111",
                }}
            >
                <LabeledRow label={t('Description')} value={coupon.description} />
                <LabeledRow
                    label={t('Coupon Code')}
                    value={
                        <Typography
                            component="span"
                            sx={{
                                fontFamily: "'Roboto Condensed', sans-serif",
                                fontWeight: 700,
                                fontSize: 14,
                                color: "#E5007E",
                            }}
                        >
                            {coupon.code}
                        </Typography>
                    }
                />
                <LabeledRow label={t('Valid until')} value={coupon.validUntil.replace("Ισχύει έως ", "")} />
            </Stack>
        </Paper>
    );
}

function LabeledRow({ label, value }) {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 2,
            }}
        >
            <Typography
                sx={{
                    fontWeight: 700,
                    fontSize: 12,
                    textTransform: "uppercase",
                }}
            >
                {label}
            </Typography>
            <Box sx={{ textAlign: "right", flex: 1 }}>{value}</Box>
        </Box>
    );
}
